<template>
  <transition>
    <div>
      <engine-oil v-if="type == 1"></engine-oil>
      <transmission-oil v-if="type == 2"></transmission-oil>
      <tire v-if="type == 3"></tire>
      <oil-filter v-if="type == 4"></oil-filter>
    </div>
  </transition>
</template>

<script>
import EngineOil from "./engine-oil-recommend.vue";
import TransmissionOil from "./transmission-oil-recommend.vue";
import OilFilter from "./oil-filter-recommend.vue";
import Tire from "./tire-recommend";
// import wxsdk from "weixin-js-sdk";
import { wxShare } from "@/plugins/WxConfig.js";
export default {
  name: "detail",
  components: { EngineOil, TransmissionOil, Tire, OilFilter },
  data() {
    return {
      type: null,
    };
  },
  mounted() {
    this.type = this.$route.query.menu;
    wxShare();
    // wxsdk.ready(() => {
    //   console.log("======");
    //   window.sessionStorage.setItem("wxsdkReady", "true");
    //   // 分享给微信好友
    //   wxsdk.updateAppMessageShareData({
    //     title: "2323",
    //     link: window.location.href,
    //   });
    //   // 分享到朋友圈
    //   wxsdk.updateTimelineShareData({
    //     title: "2323",
    //     link: window.location.href,
    //   });
    // });
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.workorder-float {
  width: 150/100rem;
  height: 150/100rem;
  position: fixed;
  right: 2/100rem;
  bottom: 85/100rem;
  z-index: 10;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
